import { isTokenExpired } from '@/services/AxiosConfig';
import { CredentialService } from '@/services/CredentialService';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Vue from 'vue';
import VModal from 'vue-js-modal';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import App from './App.vue';
import router from './router';
import './share/helper'; // Import the global extension
import store from './store';
// Importing Styles
import 'admin-lte/dist/css/adminlte.min.css?v=3.2.0';
import 'admin-lte/plugins/fontawesome-free/css/all.min.css';
import 'admin-lte/plugins/icheck-bootstrap/icheck-bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'vue-simple-suggest/dist/styles.css';
import './style.scss';
// Importing Scripts
import 'admin-lte/dist/js/adminlte.min.js?v=3.2.0';
import 'admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js';
import 'admin-lte/plugins/jquery/jquery.min.js';
import 'select2/dist/css/select2.min.css';
import 'select2/dist/js/select2.full.min.js';
// import Multiselect from "vue-multi-select";
// Import the CSS

// Global Components
import Autocomplete from '@trevoreyre/autocomplete-vue';
import '@trevoreyre/autocomplete-vue/dist/style.css';
import Multiselect from 'vue-multiselect';
import AppFooter from './components/partials/AppFooter.vue';
import AppNavBar from './components/partials/AppNavBar.vue';
import AppSideBar from './components/partials/AppSideBar.vue';
import ControlSideBar from './components/partials/ControlSideBar.vue';
// Global Mixin
import DateRangePicker from 'vue2-daterange-picker';
import GlobalSizeMixin from './constants/GlobalSizeMixin';
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
// User Activity Event Setup
import { EventBus } from '@/eventBus';
import CKEditor from '@ckeditor/ckeditor5-vue';
import _ from 'lodash';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import VueSimpleSuggest from 'vue-simple-suggest';
// import './components/AppControl';
import '@trevoreyre/autocomplete-vue';
import AppActionDelete from './components/AppControl/Actions/AppActionDelete.vue';
import AppActionEdit from './components/AppControl/Actions/AppActionEdit.vue';
import AppActionPrint from './components/AppControl/Actions/AppActionPrint.vue';
import AppActionRemark from './components/AppControl/Actions/AppActionRemark.vue';
import AppInputFile from './components/AppControl/AppInputFile.vue';
import AppMultiSelectForm from './components/AppControl/AppMultiSelectForm.vue';
import AppSelectForm from './components/AppControl/AppSelectForm.vue';
import PermissionProvide from './components/AppControl/PermissionProvide.vue';
import BaseFormGroup from './components/BaseControl/BaseFormGroup.vue';
import BaseTextInput from './components/BaseControl/BaseTextInput.vue';
import { screenSize } from './constants/ConstantType';
import { IS_PERMISSION } from './constants/permission.constant';
import './directives/hasPermission';
import PermissionDirective from './directives/permission';
import { HelperService } from './share/helper.service';
import { formatCurrency, formatCurrency3Degit, formatCurrencyDash } from './utils/formatCurrency';

// ===== checktokenexpired by Syheng =====
(function checkStartupToken() {
  const token = CredentialService.getCredential()?.accessToken;
  if (token && isTokenExpired(token)) {
    CredentialService.clearCredential();
    window.location.replace('/login');
  }
})();

Vue.config.productionTip = false;

// import paperizer from 'paperizer';

Vue.config.devtools = (process.env.VUE_APP_ENV || '').toString() == 'development' ? true : false;

if ((process.env.VUE_APP_ENV || '').toString() == 'production') {
  Vue.config.errorHandler = function (err, vm, info) {
    // console.log(`Error: ${err.toString()}\nInfo: ${info}`);
  };
  Vue.config.warnHandler = function (msg, vm, trace) {
    // console.log(`Warn: ${msg}\nTrace: ${trace}`);
  };
}

// Define a global filter
Vue.filter('dateFormat', function (value) {
  if (value) {
    return moment(value).format('DD/MM/YY'); // Customize your date format here
  }
  return '';
});

// Define a global filter
Vue.filter('dateTimeFormat', function (value) {
  if (value) {
    return moment(value).format('DD/MM/YY - hh:mmA'); // Customize your date format here
  }
  return '';
});

// Define a global filter
Vue.filter('currencyFormat', function (value) {
  if (value) {
    return HelperService.formatCurrency(value); // Customize your date format here
  }
  return '';
});

Vue.use(Autocomplete);
Vue.use(CKEditor);
// Use Plugins
Vue.use(router);
Vue.use(store);
Vue.use(Toast, {
  // Your toast options here
});
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VModal);

// Attach PERMISSION to prototype
Vue.prototype.$PERMISSION = IS_PERMISSION;
Vue.prototype.$uuidv4 = uuidv4;
Vue.prototype.$udid = uuidv4;
Vue.prototype.$userInfo = store.getters.getUserInfo;
Vue.prototype.$baseUrl = process.env.VUE_APP_DEV_URL;
Vue.prototype.$screenWidth = () => window.innerWidth;
Vue.prototype.$screenSize = screenSize;
Vue.prototype.$isAdmin = () => store.getters['userPermission/isAdmin'];

Vue.directive('permission', PermissionDirective);

Vue.component('base-box', () => import('./components/BaseControl/BaseBox.vue'));
// Register Global Components
Vue.component('AppNavBar', AppNavBar);
Vue.component('AppSideBar', AppSideBar);
Vue.component('AppFooter', AppFooter);
Vue.component('ControlSideBar', ControlSideBar);

Vue.component('multi-select', Multiselect);
Vue.component('app-single-select', AppSelectForm);
Vue.component('app-multi-select', AppMultiSelectForm);
Vue.component('date-range-picker', DateRangePicker);
Vue.component('base-form-group', BaseFormGroup);
Vue.component('base-input', BaseTextInput);
Vue.component('input-file', AppInputFile);
Vue.component('vue-simple-suggest', VueSimpleSuggest);
Vue.component('permission-provide', PermissionProvide);
Vue.component('action-edit', AppActionEdit);
Vue.component('action-delete', AppActionDelete);
Vue.component('action-print', AppActionPrint);
Vue.component('action-remark', AppActionRemark);
Vue.component('pm', PermissionProvide);
// Vue.component("multi-select", VueMultiselect);
// Mixin
Vue.mixin(GlobalSizeMixin);
Vue.prototype.$moment = moment;

Vue.prototype.$scrollToFirstError = async function ($el) {
  $el ??= this.$el;
  this.$nextTick(() => {
    const errorElements = $el.querySelector('.is-invalid,input[type="text"]+.text-danger');

    if (errorElements) {
      const topPosition = errorElements.getBoundingClientRect().top + window.scrollY - 150;
      window.scrollTo({ top: topPosition, behavior: 'smooth' });
    }
  });
};

Vue.prototype.$checkPermission = function (permission) {
  return store.getters['userPermission/hasPermission'](permission);
};

Vue.filter('currency', formatCurrency);
Vue.filter('currency3Degit', formatCurrency3Degit);
Vue.filter('currencyDash', formatCurrencyDash);
// Create Vue instance
new Vue({
  router,

  store,
  render: (h) => h(App),
}).$mount('#app');

const events = ['mousemove', 'keydown', 'click', 'scroll'];
const resetTimer = _.debounce(() => {
  EventBus.$emit('user-activity');
}, 500);

events.forEach((event) => {
  window.addEventListener(event, resetTimer);
});

const cleanupListeners = () => {
  events.forEach((event) => {
    window.removeEventListener(event, resetTimer);
  });
};

window.addEventListener('beforeunload', cleanupListeners);
